const Footer = () => {
  return (
    <div className="flex w-full flex-col items-center justify-between px-1 pb-8 pt-3 lg:px-8 xl:flex-row">
      <h5 className="mb-4 text-center text-sm font-medium text-gray-600 sm:!mb-0 md:text-lg">
        <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0 md:text-base">
          ©{1900 + new Date().getYear()} Ananya Enterprises. All Rights
          Reserved.
        </p>
      </h5>
      <div>
        <p className="mb-4 text-center text-sm text-gray-600 sm:!mb-0 md:text-base">
          {" "}
          Design & Devloped By{" "}
          <a href="https://www.webbocket.com/" className="text-[#640708]">
            Web Bocket Private Ltd.
          </a>
        </p>
      </div>
    </div>
  );
};

export default Footer;
